import * as Sentry from '@sentry/react';
import type { BackendModule } from 'i18next';

import type { Env } from '@izimi/core';
import { appEnv, initializeI18n, namespaces } from '@izimi/core';

const SENTRY_LOGGING_ENVS: Env[] = ['acc', 'production'];

const read: BackendModule['read'] = async (language, namespace, callback) => {
  const json = namespaces.includes(namespace)
    ? await import(`../../../../../shared/izimi-i18n/locales/${language}/${namespace}.json`)
    : await import(`./locales/${language}/${namespace}.json`);
  callback(null, json);
};

const onMissingKey = (namespace: string, key: string) => {
  if (SENTRY_LOGGING_ENVS.includes(appEnv)) {
    Sentry.captureMessage('[i18n] Missing translation', {
      level: 'warning',
      tags: {
        namespace,
        key,
      },
    });
  }
};

initializeI18n(read, { logMissing: import.meta.env.DEV, onMissingKey });
